import { useState , useEffect} from "react";
import NavBar from "../components/NavBar";
import Header from "../components/Header";
import Category from "../components/Category";
import ProductList from "../components/ProductList";
import Others from "../components/Other";
import Brand from "../components/Brand";
import Footer from "../components/Footer";

import Cargo from "./Cargo";
import ModalApp from "../components/ModalApp";

export default function Home() {
    const [clickedCat, setClickedCat] = useState(null);
    const [showModal, setShowModal] = useState(true);

    useEffect(() => {
        document.title = "Achetez tous vos produits américains en un clic - dollarstoretogo.com";
      }, []);

  const handleCategoryClick = (id, label) => {
    setClickedCat({ id, label });
    //alert("Cat ID:"+ id); 
  };
  return (
    <>
    <NavBar />
    <Header 
    title="DOLLAR STORE"
    subtitle="Votre boutique Américaine au TOGO,
    Tel: +228 90 04 59 26"
    tiktokUrl="https://www.tiktok.com/@dollarstore_lome"
  facebookUrl="https://www.facebook.com/CofitelDollarStore"
    />
    <Category onSelect={handleCategoryClick}/>
     <ProductList getType={clickedCat}/>
     <Cargo />
     <Others />
     
     <Brand />
     <Footer />
     {showModal && (
        <ModalApp onClose={() => setShowModal(false)} />
      )}
    </>
  );
}
